export default __webpack_public_path__ + "static/media/instagram.e29251bd.svg";